import React, { useEffect, useRef, useState } from 'react';
import Header from '../components/Header';
import Leftmenu from '../components/Leftmenu';
import Rightmenu from '../components/Rightmenu';
import { useOutletContext, Link } from "react-router-dom";
import Campusback from '../../images/profile-banner.jpg';
import PostCard from '../components/PostCard';
import df from "../../images/Default_pfp.jpg";

const formatDate = (dateStr) => {
    if (!dateStr) return "";
    try {
        const parts = dateStr.split('-');
        if (parts.length === 3) {
            const d = new Date(parts[0], parts[1] - 1, parts[2]);
            return d.toLocaleDateString('en-US', { month: 'short', year: 'numeric' });
        }
        return dateStr;
    } catch (e) {
        return dateStr;
    }
};

function Profile() {
    const { user, token } = useOutletContext();
    const workHistory = user?.work_history || [];
    const currentJob = workHistory.find(j => j.is_current == 1 || j.is_current === true || j.is_current === "1")
        || (workHistory.length > 0 ? workHistory[0] : null);
    const [posts, setPosts] = useState([]);
    const [activeTab, setActiveTab] = useState('about');

    // Pagination
    const loaderRef = useRef(null);
    const [page, setPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const [hasMore, setHasMore] = useState(true);
    const [selectedImages, setSelectedImages] = useState([]);
    const [submittingPost, setSubmittingPost] = useState(false);

    const handleImageChange = (e) => {
        const files = Array.from(e.target.files || []);
        setSelectedImages(files);
    };

    const postCreate = (e) => {
        e.preventDefault();
        const message = e.target.message.value.trim();
        if (!message && selectedImages.length === 0) return;

        setSubmittingPost(true);
        const formData = new FormData();
        for (let i = 0; i < selectedImages.length; i++) {
            formData.append('images[]', selectedImages[i]);
        }
        formData.append('message', message);

        fetch('/api/post-create', {
            method: "POST",
            headers: {
                Authorization: `Bearer ${token}`,
            },
            body: formData,
        })
            .then((response) => response.json())
            .then((data) => {
                setSubmittingPost(false);
                if (data.data && data.message) {
                    e.target.reset();
                    setSelectedImages([]);
                    setPosts((prev) => [data.data, ...prev]);
                }
            })
            .catch((error) => {
                setSubmittingPost(false);
                console.error("Post creation error:", error);
            });
    };

    const getPosts = () => {
        if (loading || !hasMore) return;
        setLoading(true);

        fetch('/api/get-user-posts?page=' + page, {
            method: "POST",
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ id: user?.id })
        })
            .then((response) => response.json())
            .then((data) => {
                setLoading(false);
                if (data?.data?.data && data.data.data.length > 0) {
                    setPosts((prevPosts) => [...prevPosts, ...data.data.data]);
                    setHasMore(data.data.data.length > 0);
                } else {
                    setHasMore(false);
                }
            })
            .catch((error) => {
                console.error("Error fetching user posts:", error);
                setLoading(false);
                setHasMore(false);
            });
    };

    // Watch for loader in viewport
    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                if (entries[0].isIntersecting) {
                    setPage((prevPage) => {
                        if (!loading && hasMore) {
                            return prevPage + 1;
                        }
                        return prevPage;
                    });
                }
            },
            { threshold: 0.1 }
        );

        if (loaderRef.current) observer.observe(loaderRef.current);
        return () => {
            if (loaderRef.current) observer.unobserve(loaderRef.current);
        };
    }, [loading, hasMore]);

    // Fetch new posts when page changes
    useEffect(() => {
        if (page > 1) {
            getPosts();
        }
    }, [page]);

    useEffect(() => {
        if (user?.id) {
            getPosts();
        }
    }, [user?.id]);

    const profilePic = user?.personal_info?.profile_picture || df;

    return (
        <div>
            <Header />
            <Leftmenu />
            <Rightmenu />

            <div className="main-content right-chat-active">
                <div className="middle-sidebar-bottom">
                    <div className="middle-sidebar-left">
                        <div className="row">
                            {/* Profile Header Banner Card */}
                            <div className="col-lg-12">
                                <div className="card w-100 border-0 p-0 bg-white shadow-xss rounded-xxl overflow-hidden mb-3">
                                    <div className="card-body h250 p-0 rounded-xxl overflow-hidden m-3 position-relative">
                                        <img
                                            src={Campusback}
                                            alt="Campus Banner"
                                            style={{ width: '100%', height: '300px', objectFit: 'contain', objectPosition: 'center center' }}
                                        />
                                    </div>

                                    <div className="card-body p-0 position-relative pb-3">
                                        <figure className="avatar-2 position-absolute w100 z-index-1" style={{ top: '-45px', left: 30 }}>
                                            <img
                                                src={profilePic}
                                                alt={user?.name || "User Avatar"}
                                                className="float-right p-1 bg-white rounded-circle w-100 shadow-md"
                                                style={{ aspectRatio: '1/1', objectFit: 'cover', objectPosition: 'center' }}
                                            />
                                        </figure>

                                        <div className="d-flex flex-wrap justify-content-between align-items-center pl-15 pe-4 pt-2">
                                            <div>
                                                <h4 className="fw-700 font-sm mb-1 text-grey-900 d-flex align-items-center gap-2">
                                                    {user?.name}
                                                    <span
                                                        className="badge rounded-pill text-uppercase font-xsssss px-2 py-1 fw-bold text-white"
                                                        style={{ backgroundColor: '#E42026' }}
                                                    >
                                                        {user?.role || "Member"}
                                                    </span>
                                                </h4>

                                                {currentJob && currentJob.designation && (
                                                    <p className="fw-600 font-xssss text-grey-600 mb-1">
                                                        <i className="feather-briefcase me-1 text-grey-500"></i>
                                                        {currentJob.designation}
                                                        {(currentJob.organisation || currentJob.organization) && ` at ${currentJob.organisation || currentJob.organization}`}
                                                    </p>
                                                )}


                                            </div>

                                            <div className="d-flex align-items-center gap-2 mt-3 mt-md-0">
                                                <Link
                                                    to="/update-profile/personal"
                                                    className="d-inline-flex align-items-center gap-2 text-white font-xssss fw-600 px-4 py-2 rounded-xl text-decoration-none shadow-sm"
                                                    style={{ backgroundColor: '#E42026' }}
                                                >
                                                    <i className="feather-edit-2 font-xs"></i>
                                                    <span>Edit Profile</span>
                                                </Link>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Tabs */}
                                    <div className="card-body d-block w-100 shadow-none mb-0 p-0 border-top-xs">
                                        <ul className="nav nav-tabs h55 d-flex product-info-tab border-bottom-0 ps-4">
                                            <li className={`list-inline-item me-4 ${activeTab === 'about' ? 'active' : ''}`}>
                                                <a
                                                    className={`fw-700 font-xssss pt-3 pb-3 ls-1 d-inline-block text-decoration-none ${activeTab === 'about' ? 'text-dark border-bottom border-danger border-2' : 'text-grey-500'}`}
                                                    href="#about"
                                                    onClick={(e) => { e.preventDefault(); setActiveTab('about'); }}
                                                >
                                                    Overview
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            {/* Left Sidebar Info Cards */}
                            <div className="col-xl-4 col-xxl-3 col-lg-4 pe-lg-0">
                                {/* About / Bio Card */}
                                <div className="card w-100 shadow-xss rounded-xxl border-0 mb-3">
                                    <div className="card-body d-block p-4">
                                        <h4 className="fw-700 mb-2 font-xsss text-grey-900 d-flex align-items-center gap-2">
                                            <i className="feather-info text-danger"></i> About Me
                                        </h4>
                                        <p className="fw-500 text-grey-600 lh-24 font-xssss mb-0">
                                            {user?.personal_info?.bio || "Welcome to my alumni profile. Add your bio in profile settings to tell fellow alumni about yourself!"}
                                        </p>
                                    </div>
                                </div>

                                {/* Professional Details Card */}
                                <div className="card w-100 shadow-xss rounded-xxl border-0 mb-3">
                                    <div className="card-body p-4">
                                        <h4 className="fw-700 mb-3 font-xsss text-grey-900 d-flex align-items-center gap-2">
                                            <i className="feather-briefcase text-danger"></i> Professional
                                        </h4>

                                        {user?.professional_info?.employability_status || (user?.professional_info?.work_status && user.professional_info.work_status !== 'none') ? (
                                            <div className="mb-3 d-flex flex-wrap gap-2">
                                                {user?.professional_info?.employability_status && (
                                                    <div>
                                                        <small className="text-grey-500 fw-600 font-xsssss text-uppercase d-block mb-1">Status</small>
                                                        <span className="badge bg-light text-dark font-xssss fw-600 px-3 py-1 rounded-pill border text-capitalize">
                                                            {user.professional_info.employability_status}
                                                        </span>
                                                    </div>
                                                )}
                                                {user?.professional_info?.work_status && user.professional_info.work_status !== 'none' && (
                                                    <div>
                                                        <small className="text-grey-500 fw-600 font-xsssss text-uppercase d-block mb-1">Work Status</small>
                                                        <span className="badge bg-light text-dark font-xssss fw-600 px-3 py-1 rounded-pill border text-capitalize">
                                                            {user.professional_info.work_status.replace(/_/g, ' ')}
                                                        </span>
                                                    </div>
                                                )}
                                            </div>
                                        ) : (!workHistory || workHistory.length === 0) ? (
                                            <p className="font-xssss text-grey-500 mb-0">No professional details added yet.</p>
                                        ) : null}

                                        {/* Experience */}
                                        <div className="mt-3 pt-3 border-top">
                                            <h5 className="fw-700 font-xsss text-grey-900 mb-3">Experience</h5>
                                            {workHistory && workHistory.length > 0 ? (
                                                workHistory.map((job, idx) => {
                                                    const isCurrent = job.is_current == 1 || job.is_current === true || job.is_current === "1";
                                                    const startFormatted = formatDate(job.start_date);
                                                    const endFormatted = isCurrent ? "Present" : (formatDate(job.end_date) || "Present");
                                                    const dateDisplay = startFormatted ? `${startFormatted} - ${endFormatted}` : (endFormatted === "Present" ? "Present" : "");

                                                    return (
                                                        <div key={idx} className={`pb-2 ${idx !== workHistory.length - 1 ? 'mb-3 border-bottom border-light' : ''}`}>
                                                            <h6 className="font-xsss fw-700 text-grey-900 mb-0">
                                                                {job.organisation || job.organization}
                                                            </h6>
                                                            <p className="font-xssss fw-600 text-grey-700 mb-1">
                                                                {job.designation}
                                                            </p>
                                                            {dateDisplay && (
                                                                <span className="font-xsssss text-grey-500 d-block">
                                                                    <i className="feather-calendar me-1"></i>
                                                                    {dateDisplay}
                                                                </span>
                                                            )}
                                                        </div>
                                                    );
                                                })
                                            ) : (
                                                <p className="font-xssss text-grey-500 mb-0">No professional experience added yet.</p>
                                            )}
                                        </div>
                                    </div>
                                </div>

                                {/* Academic Details Card */}
                                <div className="card w-100 shadow-xss rounded-xxl border-0 mb-3">
                                    <div className="card-body p-4">
                                        <h4 className="fw-700 mb-3 font-xsss text-grey-900 d-flex align-items-center gap-2">
                                            <i className="feather-award text-danger"></i> Education
                                        </h4>

                                        {user?.academic_info?.graduation_degree ? (
                                            <div>
                                                <div className="mb-3">
                                                    <small className="text-grey-500 fw-600 font-xsssss text-uppercase d-block mb-1">Graduation</small>
                                                    <h5 className="font-xsss fw-700 text-grey-900 mb-0">

                                                        {user.academic_info.graduation_course && ` ${user.academic_info.graduation_course}`}
                                                    </h5>
                                                    <p className="font-xssss fw-500 text-grey-600 mb-0">
                                                        {user.academic_info.graduation_institution || "Techno India University, Tripura"}
                                                    </p>
                                                    {user.academic_info.graduation_end_year && (
                                                        <small className="font-xsssss text-grey-500">
                                                            Year of Passing: {user.academic_info.graduation_end_year}
                                                        </small>
                                                    )}
                                                </div>

                                                {user?.academic_info?.post_graduation_degree && (
                                                    <div className="pt-2 border-top">
                                                        <small className="text-grey-500 fw-600 font-xsssss text-uppercase d-block mb-1">Post Graduation</small>
                                                        <h5 className="font-xsss fw-700 text-grey-900 mb-0">

                                                            {user.academic_info.post_graduation_course && ` ${user.academic_info.post_graduation_course}`}
                                                        </h5>
                                                        <p className="font-xssss fw-500 text-grey-600 mb-0">
                                                            {user.academic_info.post_graduation_institution}
                                                        </p>
                                                    </div>
                                                )}
                                            </div>
                                        ) : (
                                            <p className="font-xssss text-grey-500 mb-0">No academic records linked yet.</p>
                                        )}
                                    </div>
                                </div>

                                {/* Personal & Contact Information Card */}
                                <div className="card w-100 shadow-xss rounded-xxl border-0 mb-3">
                                    <div className="card-body p-4">
                                        <h4 className="fw-700 mb-3 font-xsss text-grey-900 d-flex align-items-center gap-2">
                                            <i className="feather-user text-danger"></i> Contact & Details
                                        </h4>

                                        <ul className="list-unstyled mb-0 font-xssss">
                                            <li className="d-flex align-items-center mb-2">
                                                <i className="feather-mail me-2 text-grey-500 font-xs"></i>
                                                <span className="text-grey-700 text-truncate">{user?.email}</span>
                                            </li>

                                            {user?.phone && (
                                                <li className="d-flex align-items-center mb-2">
                                                    <i className="feather-phone me-2 text-grey-500 font-xs"></i>
                                                    <span className="text-grey-700">{user.phone}</span>
                                                </li>
                                            )}



                                            {user?.personal_info?.gender && (
                                                <li className="d-flex align-items-center mb-2">
                                                    <i className="feather-user-check me-2 text-grey-500 font-xs"></i>
                                                    <span className="text-grey-700 text-capitalize">{user.personal_info.gender}</span>
                                                </li>
                                            )}
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            {/* Right Column: Create Post & Feed */}
                            <div className="col-xl-8 col-xxl-9 col-lg-8">
                                {/* Create Post Form */}
                                <form onSubmit={postCreate} className="card w-100 shadow-xss rounded-xxl border-0 ps-4 pt-4 pe-4 pb-3 mb-3">
                                    <div className="card-body p-0">
                                        <div className="font-xssss fw-600 text-grey-500 card-body p-0 d-flex align-items-center">
                                            <i className="btn-round-sm font-xs text-danger feather-edit-3 me-2 bg-greylight"></i>
                                            <span>Share an update with your alumni network</span>
                                        </div>
                                    </div>

                                    <div className="card-body p-0 mt-3 position-relative">
                                        <figure className="avatar position-absolute ms-2 mt-1 top-5">
                                            <img
                                                src={profilePic}
                                                alt="image"
                                                className="shadow-sm rounded-circle w30"
                                                style={{ aspectRatio: '1/1', objectFit: 'cover' }}
                                            />
                                        </figure>
                                        <textarea
                                            id="message"
                                            name="message"
                                            className="h100 bor-0 w-100 rounded-xxl p-2 ps-5 font-xssss text-grey-700 fw-500 border-light-md theme-dark-bg"
                                            cols="30"
                                            rows="10"
                                            placeholder="What's on your mind? Share an achievement, job opening, or update..."
                                        ></textarea>
                                    </div>

                                    {/* Selected Images Preview */}
                                    {selectedImages.length > 0 && (
                                        <div className="row ps-2 pe-2 mt-2">
                                            {selectedImages.slice(0, 3).map((image, index) => (
                                                <div key={index} className="col-4 p-1">
                                                    <img
                                                        className="rounded-3 w-100 shadow-xs"
                                                        alt="preview"
                                                        src={URL.createObjectURL(image)}
                                                        style={{ height: '100px', objectFit: 'cover' }}
                                                    />
                                                </div>
                                            ))}
                                            {selectedImages.length > 3 && (
                                                <div className="col-12 mt-1">
                                                    <small className="text-muted fw-600 font-xssss">
                                                        +{selectedImages.length - 3} more photos selected
                                                    </small>
                                                </div>
                                            )}
                                        </div>
                                    )}

                                    <div className="card-body d-flex p-0 mt-3 justify-content-between align-items-center">
                                        <input
                                            type="file"
                                            id="file-upload"
                                            className="visually-hidden"
                                            multiple
                                            accept="image/*"
                                            onChange={handleImageChange}
                                        />

                                        <label
                                            htmlFor="file-upload"
                                            className="d-flex align-items-center font-xssss fw-600 ls-1 text-grey-700 pe-4 mb-0"
                                            style={{ cursor: 'pointer' }}
                                        >
                                            <i className="font-md text-success feather-image me-2"></i>
                                            <span>Attach Photos</span>
                                        </label>

                                        <button
                                            type="submit"
                                            className="btn text-white font-xssss fw-600 px-4 py-2 rounded-xl d-flex align-items-center justify-content-center"
                                            style={{ backgroundColor: '#E42026', minWidth: '100px' }}
                                            disabled={submittingPost}
                                        >
                                            {submittingPost ? (
                                                <>
                                                    <span className="spinner-border spinner-border-sm me-1" role="status"></span>
                                                    Posting...
                                                </>
                                            ) : (
                                                "Post"
                                            )}
                                        </button>
                                    </div>
                                </form>

                                {/* Posts Feed */}
                                {posts.length > 0 ? (
                                    posts.map((post) => (
                                        <PostCard
                                            key={post.id}
                                            post={post}
                                            onDelete={(deletedId) =>
                                                setPosts((prev) => prev.filter((p) => p.id !== deletedId))
                                            }
                                        />
                                    ))
                                ) : (
                                    !loading && (
                                        <div className="card w-100 text-center shadow-xss rounded-xxl border-0 p-5 mb-3">
                                            <i className="feather-edit font-xl text-grey-400 mb-2"></i>
                                            <h5 className="fw-700 font-xs text-grey-700 mb-1">No Posts Yet</h5>
                                            <p className="text-grey-500 font-xssss mb-0">Share your first post above to start engaging with alumni!</p>
                                        </div>
                                    )
                                )}

                                {/* Infinite Scroll Loader */}
                                <div
                                    ref={loaderRef}
                                    className="card w-100 text-center shadow-xss rounded-xxl border-0 p-4 mb-3 mt-3"
                                >
                                    {hasMore ? (
                                        <div className="snippet mt-2 ms-auto me-auto">
                                            <div className="stage">
                                                <div className="dot-typing"></div>
                                            </div>
                                        </div>
                                    ) : (
                                        <p className="text-muted mb-0 font-xssss">You have reached the end of your feed</p>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Profile;
